module.exports = __webpack_public_path__ + "static/foto1-09ae3df248362ebbf655509eaded6e76.jpg";